import React, { useEffect } from 'react';
import { useDispatch, useGlobal } from 'reactn';
import { GridList, Theme, createStyles, LinearProgress, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

//import { RootState } from '../../app/reducers';
import { Applicazione } from '../../models/applicazione';
import { ApplicazioneCard } from './applicazione';
// import { Header } from '../../components/header';
//import actions from '../../business/principal/actions';
//import withAuthentication from '../../components/withAuthentication';
import Sidebar from './sidebar';
// import Oidc, { Log } from 'oidc-client';
import IForfettariAppBar from '../../appBar/IForfettariAppBar';
import Main from '../../components/main';
import { IGlobalState } from '../../states/GlobalState';
import { getApplicazioni } from '../../services/applicazioneService';
import { Applicazioni } from '../../types/types';
import { Company, CompanySearchModel } from '../../models/company';
import { getCompanies } from '../../services/companyServices';
import { Roles } from '../../models';
import moment from 'moment';
import { useLogger } from '../../logger';
import { WhatsNewSearchModel, WhatsNew } from '../../models/whatsNew';
import { getWhatsNews } from '../../services/whatsNewServices';
import {WhatsNewDialog} from '../../dialog/WhatsNewDialog';
import { PrincipalWhatsNew } from '../../models/principalWhatsNew';
import { insertPrincipalWhatsNew } from '../../services/principalWhatsNewService';
import { ApplicazioniValue } from '../../utils/costanti';
import { getFederatedApp } from '../../services/federationService';
import { QuestionAnswer } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column',
            height: '100vh',
            backgroundColor: '#eee'
        },
        container: {
            display: 'flex',
            flex: 1,
            height: 'calc(100vh - 64px)'
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            height: '100%',
            overflowY: 'auto',
            backgroundColor: theme.palette.background.default,
            minWidth: 0,
            [theme.breakpoints.down('sm')]: {
                width: 0
            }
        },
        sidebar: {
            flex: 1,
            backgroundColor: 'rgba(128, 128, 128, 0.1)',
            height: '100%',
            padding: '2rem'
        },
        grid: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-around',
            maxWidth: 600
            // overflow: 'hidden'
            //backgroundColor: theme.palette.background.paper,
        }
    })
);

interface ViewProps {
    isBusy: boolean;
    applicationList: Applicazione[];
    user: any;
}
export default function DashboardView() {

    const classes = useStyles();
    //const dispatch = useDispatch();
    const [current, setCurrent] = React.useState(-1);
    //const [companyName, setCompanyName] = React.useState('');
    const [identity,] = useGlobal<IGlobalState, 'identity'>('identity');
    const [auth,] = useGlobal<IGlobalState, 'auth'>('auth');
    const [ip,] = useGlobal<IGlobalState, 'ip'>('ip');
    const [applicationList,setApplicationList] = useGlobal<IGlobalState, 'applicationList'>('applicationList');
    const [isBusy, setIsBusy] = useGlobal<IGlobalState, 'isBusy'>('isBusy');
    const [companies, setCompanies] = useGlobal<IGlobalState, 'companies'>('companies');
    const [, setApplication] = useGlobal<IGlobalState, 'application'>('application');
    const [title, setTitle] = useGlobal<IGlobalState, 'title'>('title');
    const [warningDisabled, setWarningDisabled] = React.useState<string | null>(null);
    const logger = useLogger({key: 'Applicazione'});
    let company: Company = Company.newItem();
    const [isOpen, setIsOpen] = React.useState<boolean>(false);
    const [news, setNews] = React.useState<WhatsNew | null>(null);

    const p: ViewProps = {
        isBusy: isBusy, // principal.isBusy,
        applicationList: applicationList,
        user: auth.user
    };

    const getApp = async () => {
        if (!identity?.Company?.IsFederated) {
            let myApp = await getApplicazioni(ip, auth.authData!, auth.user!, identity!);
            setApplicationList(myApp);
        } else {
            //Case Visura Federated
            let myApp = await getFederatedApp(ip, auth.authData!, auth.user!, identity!);
            setApplicationList(myApp);
        }
    }

    const loadCompanies = async () => {
        let companyList = await getCompanies(ip, auth.authData!, auth.user!, new CompanySearchModel());
        setCompanies(companyList);
    }
    
    const manageTitle = (): void => {
        company = companies.find(x => x.Id === identity?.CompanyId)!;
        if (company) {        
            setTitle(`${company.ApplicationName}`);
        } else {
            setTitle('ConsulTool');
        }
    }
    
    const getNews = async () => {
        let model: WhatsNewSearchModel = new WhatsNewSearchModel();
        model.Version = process.env.REACT_APP_VERSION;
        model.PrincipalId = identity?.Id;
        model.IsForUser = true;
        model.OnlyActive = true;
        console.log('index: sto per recuperare le news');
        let res = await (await getWhatsNews(ip, auth.authData!, auth.user!, model));
        console.log('index: ho recuperato le news');
        if (res && res.ResultList && res.ResultList.length > 0) {
            setNews(res.ResultList[0]);            
            setIsOpen(true);
        }
    }

    const handleCloseNews = (checked: boolean) => {
        if (checked === true) {
            // Devo scrivere il Record in PrincipalWhatsNew con Hide = 1
            let model: PrincipalWhatsNew = PrincipalWhatsNew.newItem(identity!.Id);
            model.WhatsNewId = news!.Id;
            model.Hide = true;
            insertPrincipalWhatsNew(ip, auth.authData!, auth.user!, model).then(res => {
                console.log('Ho salvato la news come letta dall\'utente');
            });
        }
        setIsOpen(false);  
    }

    const verifyUserDisabled = async () => {
        if (identity!.Role !== Roles.SUPERADMIN && 
            (identity!.PrincipalAuth[0].Agency?.Disabled && 
            moment(new Date()).format('YYYYMMDD') < moment(identity!.PrincipalAuth[0].Agency.Disabled!).format('YYYYMMDD'))
        )
        {
            // console.log('Avviso studio disabilitato a breve');
            logger.warning('Attenzione. Studio sarà disabilitato in data: ' + moment(identity!.PrincipalAuth[0].Agency.Disabled!).format('DD/MM/YYYY'), 'SCADENZA STUDIO');
            setWarningDisabled(moment(identity!.PrincipalAuth[0].Agency.Disabled!).format('DD/MM/YYYY'));
        } 
    }
    
    useEffect(() => {
        setIsBusy(true);        
        loadCompanies();
        setApplication(Applicazioni.Home);
        manageTitle();
        if (!identity?.Company?.IsFederated) {
            verifyUserDisabled();
            getNews();
        }
        getApp();
        setIsBusy(false);
        
    }, []);
    
    return (
        <div style={{ backgroundColor: "#e3e3e3", minHeight: "100vh" }}>
        <IForfettariAppBar title={title} handleLoad={() => {}} handleChange={() =>{}}></IForfettariAppBar>
        <WhatsNewDialog open={isOpen} handleClose={handleCloseNews} title={news?.Title!} message={news?.HtmlContent!} version={process.env.REACT_APP_VERSION!}/>
        <Main>
            <div className={classes.root}>
                <div className={classes.container}>
                    <div className={classes.content}>
                        {p.isBusy ? <LinearProgress variant="indeterminate" /> : null}                    
                        <GridList className={classes.grid} cols={2} style={{ margin: '0 auto', padding: '1rem' }}>
                            {p.applicationList && p.applicationList.map((item, index) => 
                                (item.Guid !== ApplicazioniValue.EasyStart || (item.Guid === ApplicazioniValue.EasyStart && identity?.Company?.HasEasyStart === true)) ? (                                                        
                                    <ApplicazioneCard key={index} item={item} onClickInfo={setCurrent} />
                                ) : null
                            )}
                        </GridList>
                    </div>
                    <div className={classes.sidebar}>
                        <Sidebar applicazione={current} warningDisabled={warningDisabled} identity={identity}/>
                    </div>
                </div>
            </div>
        </Main>
        </div>
    );
}
